import { ID } from "@libs/interfaces/layouts"
import ConfirmButton from "@libs/useful/ConfirmButton"
import { __ } from "@libs/utilities"
import { IDestrict, IPEFestSchool } from "@/modules/pe-fest-module/data/interfaces"
import { EditableText } from "@blueprintjs/core"
import { useState } from "react"
import { ResourceContent, ResourceIllustration } from "./DestrictCard"
import SchoolDestrictBtn from "./SchoolDestrictBtn"

/* Protopia Ecosystem component */
export interface ISchoolProps {
    item: IPEFestSchool
    onDelete: ( id: ID ) => void
    onChange: ( field: string, value: any, name?: string  ) => void
}
const SchoolCard = (props: ISchoolProps): JSX.Element => { 
    const [isContentEdit, setIsContentEdit] = useState<boolean>( false ) 
 
    const onEditContent = (bool: boolean) => {
        setIsContentEdit(bool)
    }
    const onChangeTitle = (title: string) => {
        props.onChange("title", title)
    }
    const onThumbnail = (thumbnail: string, name:string="") => {
        props.onChange( "thumbnail", thumbnail, name )
    } 
    const onChangeContent = (content: string) => {
        props.onChange("content", content)
    }
    const onChangeDestrict = (item: IDestrict) => {
        props.onChange("destrict", item?.id || "-1")
    }
    return <div className={`pe-track-edit-card-container `}>
        <div className="thumb position-relative" >  
            <ResourceIllustration 
                illustration={props.item?.thumbnail || ""}
                onChange={onThumbnail}
            /> 
            <div className="position-absolute bottom right small bg-dark text-light m-2 py-1 px-2">
                {
                    props.item.order
                }
            </div>
        </div>
        <div className="d-flex flex-column flex-grow-100">
            <div className="title"> 
                <EditableText
                    className=" px-3 py-1 track-edit-title"
                    alwaysRenderInput={true} 
                    disabled={false}
                    placeholder="Edit title..."
                    selectAllOnFocus={true} 
                    value={props.item.title}
                    onChange={onChangeTitle}
                /> 
            </div>
            <ResourceContent
                content={props.item.content}
                isContentEdit={isContentEdit}
                onChangeContent={onChangeContent}
                onEditContent={onEditContent}
            />            
            <div className="footer">
                <div className="position-relative d-flex align-items-center flex-grow-100"> 
                    <div className="d-md-flex d-none small opacity_75 pl-2">{__("Destrict")}:</div>
                    <SchoolDestrictBtn 
                        onChoose={ onChangeDestrict } 
                        destrict={ props.item.destrict }
                    />
                </div>
                <div className="position-relative flex-centered">
                    <ConfirmButton
                        buttonIcon="trash"
                        onConfirm={() => props.onDelete( props.item.id )}
                        buttonLabel={<div className="d-md-flex d-none ">{__("Delete")}</div>}
                        buttonMinimal
                    >
                        <div className="p-4">
                            {__("Really delete School?")}
                        </div>
                    </ConfirmButton> 
                </div>
            </div>
        </div>        
    </div>
}
export default SchoolCard
